<template>
  <header class="flex justify-between items-center gap-4">
    <div class="flex items-center gap-3">
      <slot name="icon" />
      <div
        v-if="title || subtitle"
        class="space-y-1"
      >
        <h3
          v-if="title"
          class="text-lg font-semibold mr-7 pr-4 leading-tight"
         
        >
          {{ title }}
        </h3>
        <p
          v-if="subtitle"
          class="text-sm text-gray-500"
         
        >
          {{ subtitle }}
        </p>
      </div>
    </div>

    <button
      v-if="enableCloseButton"
      class="size-8 rounded-full bg-transparent hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center ml-auto cursor-pointer outline-primary-950 shrink-0 self-start"
      type="button"
     
      @click="emit('close')"
    >
      <TIcon :icon="['far', 'xmark']" />
    </button>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
  enableCloseButton?: boolean
}>()

const emit = defineEmits<{
  close: []
}>()
</script>
